const imp = () => import(/* webpackChunkName: "ui_commont_icon"*/  "../sprite/loadSprite_tenant");

const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-Administratorsettings": imp,
  "Icon-Servicemonitoring": imp,
  "Icon-Tenantmanagement": imp,
  "Icon-usersettings": imp,
}
export default loadMap;